/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  DRIVER_CLOCKED_IN_STATE_CHANGE,
  DRIVERS_CLOCKED_IN_STATE_CHANGE,
  DRIVERS_COLLECTED
} from 'src/actions/driversActions';
import find from 'lodash/find';

const initialState = {
  drivers: []
};

const driversReducer = (state = initialState, action) => {
  switch (action.type) {
    case DRIVERS_COLLECTED: {
      const { drivers } = action.payload;

      return produce(state, (draft) => {
        draft.drivers = drivers;
      });
    }

    case DRIVER_CLOCKED_IN_STATE_CHANGE: {
      const { driver } = action.payload;

      return produce(state, (draft) => {
        const driverEntry = find(draft.drivers, { driverId: parseInt(driver.driverId, 10) });
        if (driverEntry) {
          driverEntry.clockedIn = driver.clockedIn;
        } else {
          draft.drivers.push({
            ...driver,
            driverId: parseInt(driver.driverId, 10)
          });
        }
      });
    }

    case DRIVERS_CLOCKED_IN_STATE_CHANGE: {
      const { drivers } = action.payload;

      return produce(state, (draft) => {
        const newDrivers = [];
        drivers.forEach((driver) => {
          const driverEntry = find(draft.drivers, { driverId: parseInt(driver.driverId, 10) });
          if (driverEntry) {
            newDrivers.push({
              ...driverEntry,
              ...driver,
              driverId: parseInt(driver.driverId, 10)
            });
          } else {
            newDrivers.push({
              ...driver,
              driverId: parseInt(driver.driverId, 10)
            });
          }
        });
        draft.drivers = newDrivers;
      });
    }

    default: {
      return state;
    }
  }
};

export default driversReducer;
